import React from 'react';

interface GenesisViewProps {
  objective: string;
  setObjective: (obj: string) => void;
  onStart: () => void;
}

export const GenesisView: React.FC<GenesisViewProps> = ({ objective, setObjective, onStart }) => (
  <div className="flex-1 flex items-center justify-center h-full min-h-[500px] bg-white dark:bg-[#050505]">
    <div className="w-full max-w-3xl px-6 flex flex-col items-center animate-in fade-in zoom-in-95 duration-500">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-10 text-center font-sans tracking-tight leading-tight max-w-2xl">
        What single long-running objective should Neura own for this project?
      </h1>
      <div className="relative w-full shadow-xl rounded-2xl group ring-1 ring-gray-200 dark:ring-gray-800 focus-within:ring-2 focus-within:ring-black dark:focus-within:ring-white transition-all bg-white dark:bg-[#111112]">
        <textarea
          autoFocus
          value={objective}
          onChange={(e) => setObjective(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onStart();
            }
          }}
          placeholder="e.g. Audit our top 5 competitors continuously and alert me to pricing changes..."
          className="w-full bg-transparent border-none rounded-2xl py-6 px-6 pr-20 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-600 outline-none resize-none font-sans text-xl leading-relaxed min-h-[160px]"
        />
        <button
          onClick={onStart}
          disabled={!objective.trim()}
          className="absolute right-4 bottom-4 w-12 h-12 rounded-xl bg-black dark:bg-white text-white dark:text-black flex items-center justify-center hover:scale-105 active:scale-95 transition-all disabled:opacity-50 disabled:hover:scale-100 shadow-md"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
);
